import React, { useEffect, useMemo } from 'react';
import {
  ActivityReport,
  activityReportQuery,
  activityReportService,
  PaginatedQuery,
  BookedByUserType,
  reservationService,
  reservationQuery,
} from '@lib/state';
import { Section } from '..';
import { useCurrentUserId, useObservable } from '../../utils';
import { ActivityExportButton } from './activity-export.button';
import { ActivityHistory } from './activity-history.component';

interface ActivityProps {
  bookedBy?: BookedByUserType;
  showActions?: boolean;
  createForGuest: boolean;
}

export const MyActivity: React.FC<ActivityProps> = ({ bookedBy, showActions, createForGuest }) => {
  const loadMore = (page?: PaginatedQuery) => {
    activityReportService.getMyActivity({}, page);
  };

  const exportChanges = (
    startDate: Date,
    endDate: Date,
    userId?: string,
    bookedBy?: BookedByUserType
  ) => {
    activityReportService.exportMyCharges(startDate, endDate, userId, bookedBy);
  };

  const userId = useCurrentUserId();

  if (!userId) return null;

  const res = useObservable(reservationQuery.reservations);

  const activity: ActivityReport[] = useObservable(activityReportQuery.activity);
  const activityResIds: string[] = useMemo(() => {
    let ids: string[] = [];
    activity
      .map(x => x.reservationId)
      .forEach(x => {
        if (x !== undefined && x !== null && !res.map(r => r.id).includes(x)) {
          ids.push(x);
        }
      });
    return ids;
  }, [activity]);

  useEffect(() => {
    if (activityResIds === undefined || activityResIds === null || activityResIds.length === 0) {
      return;
    }
    reservationService.getReservationsByIds(activityResIds);
  }, [activityResIds]);

  return (
    <Section
      title="Past Activity"
      variant="contained"
      right={
        <ActivityExportButton userId={userId} bookedBy={bookedBy} exportChanges={exportChanges} />
      }
    >
      <ActivityHistory
        activity={activity}
        reservations={res}
        userId={userId}
        loadMore={loadMore}
        showActions={showActions}
        createForGuest={createForGuest}
      />
    </Section>
  );
};
